import { gql } from 'apollo-angular';

export const SAVE_CONSIGNEES = gql`
  mutation SaveConsignee($input: ConsigneeInputDtoInput!) {
    saveConsignee(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        companyName
        countryId
        countryName
        registrationNumber
        uuid
      }
    }
  }
`;

export const DELETE_CONSIGNEE = gql`
  mutation DeleteConsignee($uuid: String!) {
    deleteConsignee(uuid: $uuid) {
      code
      data {
        active
        companyName
        countryName
        uuid
      }
      extras
      message
      status
      fieldsErrors
    }
  }
`;

export const LIST_OF_ALL_CONSIGNEES = gql`
  query ListAllConsignees($pageableParam: PageableParamInput!) {
    listAllConsignees(pageableParam: $pageableParam) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        active
        companyName
        countryName
        id
        registrationNumber
        uuid
      }
      pageable {
        pageNumber
        pageSize
      }
    }
  }
`;

export const LIST_MY_CONSIGNEES = gql`
    query ListMyConsignees($pageableParam: PageableParamInput!) {
        listMyConsignees(pageableParam: $pageableParam) {
        first
        hasContent
        hasNext
        hasPrevious
        last
        number
        numberOfElements
        size
        totalElements
        totalPages
        content {
            active
            companyName
            countryId
            countryName
            id
            registrationNumber
            uuid
        }
        pageable {
            pageNumber
            pageSize
        }
    }
}
`;

export const GET_CONSIGNEE_BY_UUID = gql`
  query GetConsigneeByUuid($uuid: String!) {
    getConsigneeByUuid(uuid: $uuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        companyName
        countryId
        countryName
        email
        id
        phoneNumber
        registrationNumber
        uuid
        directors {
          active
          email
          id
          name
          phoneNumber
          uuid
        }
      }
    }
  }
`;

